import { PrimaryProductKeys } from './primary-product-keys';
import { type PrimaryProductKey } from './product-keys';

export const SEARCH_DIALOG_WIDTH_OBSERVER_ID = 'quick-find-dialog';

export const QUICK_FIND_OPEN_INTERACTION = 'quick-find-open';
export const QUICK_FIND_CLOSE_INTERACTION = 'quick-find-close';
export const QUICK_FIND_POST_QUERY_INTERACTION = 'quick-find-post-query';
export const QUICK_FIND_LOADING_HOLD = 'quick-find-loading';

export const PRODUCTS_WITH_INLINE_FILTERS: (PrimaryProductKey | undefined)[] = [
	PrimaryProductKeys.Confluence,
	PrimaryProductKeys.Jira,
	PrimaryProductKeys.Assets,
	PrimaryProductKeys.RovoExtension,
	PrimaryProductKeys.Talent,
];

export const SEARCH_DIALOG_AI_DIALOG_REFERER_KEY = 'atlassian.search-dialog.ai-dialog.referrer';

export const DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT = 2;
